import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../actions/actionCreators"
import App from "../component/app.js";

class AppCon extends React.Component{

    constructor(props) {
        super(props);

        this.syncAudits = this.syncAudits.bind(this);
    }

    handleLogout() {
        this.props.logout();
        window.location.reload();
    }

    componentWillMount() {
        /* Charge les infos utilisateur excepté sur la page Account car déjà chargé */
        if(this.props.history.location.pathname !== "/account")
          this.props.getUserAction().then(res => {

          }).catch(err=> {
              this.handleLogout()
          })

        /* Charge les audits en attente pour afficher les notifications */
        if(this.props.audits.length === 0){
          this.props.getAuditsAction().then(res => {
          }).catch(err=> {
              this.handleLogout()
          })
        }

        /* Charge les archives en attente pour afficher les notifications */
        if(this.props.archives.length === 0){
            this.props.getArchivesAction().then(res => {

            }).catch(err=> {
                this.handleLogout()
            })
        }

        /* Charge les events de l'agenda google */
        this.props.getAuditsCalendarEventsAction().then(res => {
            //console.log(res);
        }).catch(err=> {
            //console.log(err);
        })
    }

    syncAudits(ids){
        this.props.syncAuditsAction(ids).then(res => {
            /* Charge les events de l'agenda google */
            this.props.getAuditsCalendarEventsAction().then(res => {
                //console.log(res);
            }).catch(err=> {
                //console.log(err);
            })
        }).catch(err=>{
            console.log(err);
        })
    }

    render(){
      return(
        <App  history={this.props.history} loading={this.props.loading} handleLogout={this.handleLogout.bind(this)} userInfoMissing={this.props.userInfoMissing} syncAudits={this.syncAudits} auditsCalendarEvents={this.props.auditsCalendarEvents} audits={this.props.audits ? this.props.audits : []} archives={this.props.archives ? this.props.archives : []} user={this.props.user}></App>
      )
    }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(AppCon);



// WEBPACK FOOTER //
// ./src/container/app-container.js